import { styled } from "@mui/material/styles";
import * as React from "react";
import { faintGray, faintblue, gray, white } from "../../theme/palette";
import { systemColor } from "../../theme/systemColor";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Tab, Box, Typography } from "@mui/material";
var CustomTabList = styled(TabList)({
    borderRadius: "none",
    border: "none"
});
var CustomTab = styled(Tab)({
    textTransform: "capitalize",
    fontWeight: 600,
    fontSize: "14px",
    padding: "0px",
    minHeight: "30px",
    borderRadius: "8px",
    margin: "2px",
    color: "#8593A3",
    "& .css-heg063-MuiTabs-flexContainer": {
        background: "blue"
    },
    border: "1px solid transparent",
    "&.Mui-selected": {
        color: "#000",
        backgroundColor: "#fff",
        border: '1px solid #ddd'
    }
});
export var CustomTabComponent = function (props) {
    var items = props.items, _a = props.bgColorApply, bgColorApply = _a === void 0 ? false : _a, variant = props.variant, _b = props.showTabIndicator, showTabIndicator = _b === void 0 ? false : _b, sx = props.sx, _c = props.tabVariant, tabVariant = _c === void 0 ? "scrollable" : _c;
    var _d = React.useState("1"), value = _d[0], setValue = _d[1];
    var _e = React.useState(), list = _e[0], setList = _e[1];
    React.useEffect(function () {
        setList(items);
        return function () {
            setValue("1");
        };
    }, [items]);
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    return /*#__PURE__*/ React.createElement(TabContext, {
        value: value
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: sx,
        bgcolor: bgColorApply ? white : faintGray
    }, /*#__PURE__*/ React.createElement(CustomTabList, {
        sx: {
            minHeight: "26px",
            "& .MuiTabs-indicator": {
                display: showTabIndicator ? "block" : "none"
            },
            padding: '1px'
        },
        variant: tabVariant,
        onChange: handleChange
    }, list === null || list === void 0 ? void 0 : list.map(function (item, index) { /*#__PURE__*/ return React.createElement(CustomTab, {
        sx: {
            // marginRight: "5px", 
            color: 'text.secondary',
            "&.Mui-selected": {
                border: 'none',
                bgcolor: bgColorApply ? white : faintblue
                // borderBottom: "1px solid gray",
            },
            height: '0px'
        },
        key: index,
        label: /*#__PURE__*/ React.createElement(Typography, {
            color: value === (item === null || item === void 0 ? void 0 : item.id) ? systemColor.primary : gray,
            variant: variant,
            align: "center"
        }, item === null || item === void 0 ? void 0 : item.name),
        value: item === null || item === void 0 ? void 0 : item.id
    }); }))), list === null || list === void 0 ? void 0 : list.map(function (item, index) { /*#__PURE__*/ return React.createElement(TabPanel, {
        sx: {
            padding: 1.5
        },
        key: index,
        value: item.id
    }, item.component); }));
};
